import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const CCLFamily = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Family laws here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>At <span className="kwa">KWA</span>, we specialize in offering an extensive range of legal services in both <span className="highlight">criminal and civil litigation</span> concerning <span className="highlight">family matters</span>. We recognize that disputes within the family context are deeply personal and often emotionally charged. Our seasoned legal professionals possess significant expertise in managing a wide array of issues, including but not limited to <span className="highlight">divorce</span>, <span className="highlight">child custody</span>, <span className="highlight">domestic violence</span>, and the enforcement of <span className="highlight">family court orders</span>.</p>
        <br />
        <p>We are unwavering in our commitment to advocate vigorously for the rights and interests of our clients, approaching each case with the highest degree of diligence and professionalism. Our approach involves crafting bespoke strategies tailored to the unique circumstances of each case to secure favourable outcomes.</p>
        <br />
        <p>Our team is dedicated to providing representation that is both compassionate and assertive, guiding clients through the intricacies of the criminal and civil litigation processes with exceptional skill and sensitivity. We strive to alleviate the burden on our clients by ensuring they receive thorough and effective legal support throughout their legal journey.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default CCLFamily
